import { find } from "lodash"

/**
 * Get client guardian details based on role
 */
export const getFirstGuardian = (guardians, role) => {
  return find(guardians || [], x => x.client_guardian?.client_role?.slug === role)?.client_guardian;
}